import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@potok/ui/styles/tokens.css";
import "@potok/ui/styles/themes/default.css";
import "@potok/ui/styles/themes/admin.css";
import { App } from "./App";
import "./styles/global.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Не найден элемент #root для монтирования SPA");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
